// Tag colors use the Almikia brand tints (10% and 40%), light enough for dark text
export const colors = [
  "#e9eaee",
  "#a9abbc",
  "#f8eaf1",
  "#e1abc9",
  "#faedea",
  "#edb8ac",
  "#fefbea",
  "#f9eead",
  "#f5e170",
  "#ca6da0",
];
